import React, { useEffect, useRef, useState } from 'react';
import PePapersDisclaimerGate from './shared/PePapersDisclaimerGate';
import PePapersStorageHint, { PE_PAPERS_STORAGE_HINTS } from './PePapersStorageHint';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import { savePePapersArchiveDoc } from '../../services/pePapersArchiveService';
import useAppStore from '../../store/appStore';
import { buildHtmlAsPdfBlob, downloadHtmlAsPdf } from '../../utils/pe-papers/htmlDocumentPdfDownload';

const MF_CONTRACT_PDF_CSS = `
  .av-a4-page {
    display: block !important;
    width: 100% !important;
    max-width: 210mm !important;
    margin-left: auto !important;
    margin-right: auto !important;
    box-sizing: border-box !important;
    font-family: Georgia, 'Times New Roman', serif !important;
    color: #0f172a !important;
    font-size: 12.5px !important;
    line-height: 1.42 !important;
    padding: 10mm 12mm 14mm 12mm !important;
    background: #ffffff !important;
  }
  .av-a4-page * { box-sizing: border-box !important; }
  .av-a4-page .pdf-letterhead {
    width: 100% !important;
    text-align: center !important;
    border-bottom: 2px solid #1e293b !important;
    margin: 0 0 10px !important;
    padding: 0 0 8px !important;
  }
  .av-a4-page .pdf-letterhead h1 {
    font-family: Arial, Helvetica, sans-serif !important;
    font-size: 15px !important;
    font-weight: 900 !important;
    letter-spacing: 0.06em !important;
    text-transform: uppercase !important;
    color: #0f172a !important;
    background: transparent !important;
    border: none !important;
    padding: 0 !important;
    margin: 0 0 3px !important;
    text-align: center !important;
  }
  .av-a4-page .pdf-letterhead h2 {
    font-family: Arial, Helvetica, sans-serif !important;
    font-size: 11.5px !important;
    font-weight: 700 !important;
    letter-spacing: 0.14em !important;
    text-transform: uppercase !important;
    color: #b48a56 !important;
    background: transparent !important;
    border: none !important;
    padding: 0 !important;
    margin: 0 !important;
    text-align: center !important;
  }
  .av-meta-grid {
    display: table !important;
    width: 100% !important;
    table-layout: fixed !important;
    margin: 0 0 10px !important;
    border: 1px solid #cbd5e1 !important;
    background: #f8fafc !important;
  }
  .av-meta-col {
    display: table-cell !important;
    width: 50% !important;
    vertical-align: top !important;
    padding: 9px 11px !important;
    font-size: 12px !important;
    line-height: 1.4 !important;
    color: #334155 !important;
    text-align: left !important;
  }
  .av-meta-col + .av-meta-col { border-left: 1px solid #e2e8f0 !important; }
  .av-meta-label {
    display: block !important;
    font-family: Arial, Helvetica, sans-serif !important;
    font-size: 11.5px !important;
    font-weight: 700 !important;
    text-transform: uppercase !important;
    letter-spacing: 0.12em !important;
    color: #64748b !important;
    margin: 0 0 4px !important;
  }
  .av-meta-col strong { color: #0f172a !important; font-weight: 700 !important; }
  .av-meta-col p {
    width: 100% !important;
    margin: 0 !important;
    text-align: left !important;
    font-size: 12px !important;
    line-height: 1.4 !important;
    color: #334155 !important;
  }
  .av-meta-col .av-meta-date {
    display: block !important;
    margin-top: 4px !important;
    color: #64748b !important;
    font-size: 11px !important;
  }
  .av-doc-section {
    display: block !important;
    width: 100% !important;
    margin: 0 0 8px !important;
  }
  .av-a4-page h3,
  .av-doc-section > h3 {
    display: block !important;
    width: 100% !important;
    font-family: Arial, Helvetica, sans-serif !important;
    font-size: 11px !important;
    font-weight: 700 !important;
    text-transform: uppercase !important;
    letter-spacing: 0.05em !important;
    text-align: left !important;
    background: #1e293b !important;
    color: #f8fafc !important;
    border: none !important;
    border-radius: 0 !important;
    padding: 5px 9px !important;
    margin: 0 0 5px !important;
  }
  .av-a4-page p,
  .av-doc-p,
  .av-doc-section p {
    display: block !important;
    width: 100% !important;
    max-width: 100% !important;
    font-family: Georgia, 'Times New Roman', serif !important;
    font-size: 12.5px !important;
    line-height: 1.42 !important;
    color: #1e293b !important;
    text-align: justify !important;
    margin: 0 0 5px !important;
  }
  .av-table-wrap {
    display: block !important;
    width: 100% !important;
    margin: 0 0 4px !important;
  }
  .av-table-wrap table {
    width: 100% !important;
    border-collapse: collapse !important;
    table-layout: fixed !important;
    font-size: 12.5px !important;
  }
  .av-table-wrap thead th,
  .av-table-wrap th {
    background-color: #f1f5f9 !important;
    color: #0f172a !important;
    font-family: Arial, Helvetica, sans-serif !important;
    font-size: 11px !important;
    font-weight: 600 !important;
    text-transform: uppercase !important;
    letter-spacing: 0.05em !important;
    padding: 5px 6px !important;
    border: 1px solid #64748b !important;
    border-bottom: 1.5px solid #334155 !important;
    text-align: left !important;
  }
  .av-table-wrap td {
    padding: 8px 8px !important;
    border: 1px solid #64748b !important;
    color: #334155 !important;
    text-align: left !important;
    vertical-align: middle !important;
    font-family: Arial, Helvetica, sans-serif !important;
    font-size: 12.5px !important;
    height: 32px !important;
    min-height: 32px !important;
  }
  .av-table-wrap tbody tr.signature-row td {
    height: 32px !important;
    min-height: 32px !important;
    padding: 8px 8px !important;
    border-color: #475569 !important;
  }
  @media print {
    @page { size: A4; margin: 0; }
    body { margin: 0 !important; padding: 0 !important; background: #fff !important; }
    .av-a4-page {
      box-shadow: none !important;
      margin: 0 !important;
      max-width: none !important;
      width: 100% !important;
      min-height: 0 !important;
    }
  }
`;

interface MitfuehrpflichtModalProps {
    isOpen: boolean;
    onClose: () => void;
    initialData?: any;
    onArchived?: () => void;
}

interface BetriebFormData {
    firmenname: string;
    strasse: string;
    plz: string;
    ort: string;
}

interface BetriebFieldLocks {
    firmenname: boolean;
    strasse: boolean;
    plz: boolean;
    ort: boolean;
}

const SIGNATURE_ROW_COUNT = 10;

const A4_PREVIEW_PAGE_CLASS =
    'av-a4-page bg-white text-slate-900 my-4 mx-auto w-full max-w-[210mm] h-auto min-h-0 shadow-xl rounded-sm text-left block overflow-visible print:my-0 print:shadow-none';

const DOC_P_CLASS = 'av-doc-p mb-2 text-justify text-slate-800 leading-relaxed';

const INPUT_CLASS =
    'w-full rounded-lg border border-pe-border dark:border-slate-700 bg-pe-input dark:bg-black text-pe-text dark:text-white px-4 py-2.5 text-sm focus:outline-none focus:border-[#E6C299]/50 transition-colors';

const LABEL_CLASS = 'text-xs font-semibold text-pe-muted dark:text-slate-400 uppercase tracking-wider mb-1 block';

const READONLY_INPUT_CLASS =
    'w-full rounded-lg border border-pe-border dark:border-slate-700 bg-pe-elevated dark:bg-[#0a0a0a] text-pe-accent-text dark:text-[#E6C299] px-4 py-2.5 text-sm cursor-not-allowed opacity-90';

const ERROR_INPUT_RING = 'border-red-500 focus:border-red-500 focus:ring-1 focus:ring-red-500/20';

const STEP_LABELS: Record<number, string> = {
    1: 'Datenerfassung & Überprüfung',
    2: 'Vorschau & Export',
};

const BETRIEB_AUTOCOMPLETE: Record<keyof BetriebFormData, string> = {
    firmenname: 'organization',
    strasse: 'street-address',
    plz: 'postal-code',
    ort: 'address-level2',
};

const isEmpty = (value: string) => !String(value || '').trim();

const formatTodayGerman = (): string => {
    const now = new Date();
    return `${String(now.getDate()).padStart(2, '0')}.${String(now.getMonth() + 1).padStart(2, '0')}.${now.getFullYear()}`;
};

const buildBetriebFromClient = (clientData: any): { betrieb: BetriebFormData; locks: BetriebFieldLocks } => {
    const firmenname = clientData?.salonname || clientData?.firmenname || '';
    const strasse = clientData?.strasse || '';
    const plz = clientData?.plz || '';
    const ort = clientData?.ort || '';

    return {
        betrieb: { firmenname, strasse, plz, ort },
        locks: {
            firmenname: !isEmpty(firmenname),
            strasse: !isEmpty(strasse),
            plz: !isEmpty(plz),
            ort: !isEmpty(ort),
        },
    };
};

const MitfuehrpflichtModal: React.FC<MitfuehrpflichtModalProps> = ({ isOpen, onClose, initialData, onArchived }) => {
    const [currentStep, setCurrentStep] = useState(1);
    const [betriebData, setBetriebData] = useState<BetriebFormData>({
        firmenname: '',
        strasse: '',
        plz: '',
        ort: '',
    });
    const [betriebLocks, setBetriebLocks] = useState<BetriebFieldLocks>({
        firmenname: false,
        strasse: false,
        plz: false,
        ort: false,
    });
    const [invalidFields, setInvalidFields] = useState<Set<string>>(new Set());
    const [disclaimerAccepted, setDisclaimerAccepted] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isPdfDownloading, setIsPdfDownloading] = useState(false);
    const [archiveFeedback, setArchiveFeedback] = useState<'idle' | 'success' | 'error' | 'draft'>('idle');
    const [archiveDocId, setArchiveDocId] = useState<string | null>(null);

    const printContainerRef = useRef<HTMLDivElement>(null);

    const clientData = useAppStore((state: any) => state.clientData);

    useEffect(() => {
        if (!isOpen) {
            setCurrentStep(1);
            setInvalidFields(new Set());
            setDisclaimerAccepted(false);
            setIsSaving(false);
            setArchiveFeedback('idle');
            setArchiveDocId(null);
            return;
        }

        const { betrieb, locks } = buildBetriebFromClient(clientData);
        setBetriebData(betrieb);
        setBetriebLocks(locks);
        setCurrentStep(1);
        setInvalidFields(new Set());
        setDisclaimerAccepted(false);
        setIsSaving(false);
        setArchiveFeedback('idle');
        setArchiveDocId(initialData?.id || null);

        if (initialData) {
            if (initialData.betriebData && typeof initialData.betriebData === 'object') {
                setBetriebData({ ...betrieb, ...initialData.betriebData });
                setBetriebLocks({
                    firmenname: !isEmpty(String(initialData.betriebData.firmenname ?? betrieb.firmenname)),
                    strasse: !isEmpty(String(initialData.betriebData.strasse ?? betrieb.strasse)),
                    plz: !isEmpty(String(initialData.betriebData.plz ?? betrieb.plz)),
                    ort: !isEmpty(String(initialData.betriebData.ort ?? betrieb.ort)),
                });
            }
            const step = Number(initialData.currentStep);
            if (Number.isFinite(step) && step >= 1 && step <= 2) {
                setCurrentStep(step);
            }
            if (initialData.confirmedDisclaimer) {
                setDisclaimerAccepted(true);
            }
        }
    }, [isOpen, clientData, initialData]);

    const validateStep1 = (): string[] => {
        const errors: string[] = [];

        if (isEmpty(betriebData.firmenname)) errors.push('betrieb_firmenname');
        if (isEmpty(betriebData.strasse)) errors.push('betrieb_strasse');
        if (isEmpty(betriebData.plz)) errors.push('betrieb_plz');
        if (isEmpty(betriebData.ort)) errors.push('betrieb_ort');

        return errors;
    };

    const isFieldInvalid = (field: string) => invalidFields.has(field);

    const getInputClass = (baseClass: string, field: string) =>
        isFieldInvalid(field) ? `${baseClass} ${ERROR_INPUT_RING}` : baseClass;

    const clearFieldError = (field: string) => {
        setInvalidFields((prev) => {
            if (!prev.has(field)) return prev;
            const next = new Set(prev);
            next.delete(field);
            return next;
        });
    };

    const updateBetriebField = <K extends keyof BetriebFormData>(key: K, value: BetriebFormData[K]) => {
        setBetriebData((prev) => ({ ...prev, [key]: value }));
        clearFieldError(`betrieb_${key}`);
    };

    const renderFieldError = (field: string) =>
        isFieldInvalid(field) ? (
            <p className="text-[10px] text-red-400 mt-1">Dieses Feld ist erforderlich</p>
        ) : null;

    const handleWeiter = () => {
        const errors = validateStep1();
        if (errors.length > 0) {
            setInvalidFields(new Set(errors));
            return;
        }
        setInvalidFields(new Set());
        setCurrentStep(2);
    };

    const handleZurueck = () => {
        setInvalidFields(new Set());
        setCurrentStep(1);
    };

    const handleClose = () => {
        setCurrentStep(1);
        setInvalidFields(new Set());
        setDisclaimerAccepted(false);
        setIsSaving(false);
        setArchiveFeedback('idle');
        onClose();
    };

    const isActionLocked = !disclaimerAccepted;

    const getActionButtonClass = (baseClass: string) =>
        `${baseClass} ${isActionLocked ? 'opacity-50 cursor-not-allowed' : ''}`;

    const getDocumentHtml = () =>
        printContainerRef.current?.innerHTML ||
        document.getElementById('pepapers-mitfuehrpflicht-print')?.innerHTML ||
        '';

    const buildPdfOptions = (html: string) => {
        const dateIso = new Date().toISOString().slice(0, 10);
        return {
            html,
            filename: `Mitfuehrpflicht_Zeiterfassung_${dateIso}.pdf`,
            scrubMode: 'minimal' as const,
            splitPrintBreaks: true as const,
            capturePadPx: 0,
            letterheadOnBreaks: false,
            extraCss: MF_CONTRACT_PDF_CSS,
        };
    };

    /** Druck = exakt dasselbe PDF wie Download */
    const handlePrintIsolated = async () => {
        if (isActionLocked || isPdfDownloading) return;
        const html = getDocumentHtml();
        if (!html.trim()) {
            window.alert('Dokumentinhalt fehlt — bitte Vorschau prüfen.');
            return;
        }
        setIsPdfDownloading(true);
        try {
            const blob = await buildHtmlAsPdfBlob(buildPdfOptions(html));
            const url = URL.createObjectURL(blob);
            const iframe = document.createElement('iframe');
            iframe.setAttribute('title', 'Mitführpflicht Druck');
            iframe.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0;';
            document.body.appendChild(iframe);
            const cleanup = () => {
                window.setTimeout(() => {
                    iframe.remove();
                    URL.revokeObjectURL(url);
                }, 1500);
            };
            iframe.onload = () => {
                try {
                    iframe.contentWindow?.focus();
                    iframe.contentWindow?.print();
                } finally {
                    cleanup();
                }
            };
            iframe.src = url;
        } catch (err) {
            console.error('PEPapers Mitführpflicht Druck fehlgeschlagen:', err);
            window.alert('Druckvorschau konnte nicht erstellt werden.');
        } finally {
            setIsPdfDownloading(false);
        }
    };

    const handleDownloadPdf = async () => {
        if (isActionLocked || isPdfDownloading) return;
        const html = getDocumentHtml();
        if (!html.trim()) {
            window.alert('Dokumentinhalt fehlt — bitte Vorschau prüfen.');
            return;
        }
        setIsPdfDownloading(true);
        try {
            await downloadHtmlAsPdf(buildPdfOptions(html));
        } catch (err: any) {
            console.error('PEPapers Mitführpflicht PDF-Download fehlgeschlagen:', err);
            window.alert(
                'PDF konnte nicht heruntergeladen werden: ' +
                    (String(err?.message || '').match(/setEnd|Range|offset/i)
                        ? 'PDF-Erstellung ist fehlgeschlagen. Bitte Seite neu laden und erneut versuchen.'
                        : err?.message || 'Unbekannter Fehler')
            );
        } finally {
            setIsPdfDownloading(false);
        }
    };

    const handleArchive = async (asDraft = false) => {
        if (isSaving) return;
        if (!asDraft && isActionLocked) return;

        setIsSaving(true);
        setArchiveFeedback('idle');

        const htmlContent = getDocumentHtml();

        try {
            const id = await savePePapersArchiveDoc({
                id: archiveDocId,
                documentType: 'mitfuehrpflicht-zeiterfassung',
                status: asDraft ? 'entwurf' : 'final',
                salonName: betriebData.firmenname || 'Unbekannter Salon',
                confirmedDisclaimer: asDraft ? disclaimerAccepted : true,
                currentStep,
                payload: {
                    betriebData,
                    generatedHtml: htmlContent,
                },
            });
            setArchiveDocId(id);
            setArchiveFeedback(asDraft ? 'draft' : 'success');
            onArchived?.();
            if (asDraft) {
                setTimeout(() => {
                    onClose();
                }, 600);
            } else {
                setTimeout(() => setArchiveFeedback('idle'), 3000);
            }
        } catch (error) {
            console.error('PEPapers Mitführpflicht Archivierung fehlgeschlagen:', error);
            setArchiveFeedback('error');
        } finally {
            setIsSaving(false);
        }
    };

    const renderBetriebField = (field: keyof BetriebFormData, label: string) => {
        const lockKey = field as keyof BetriebFieldLocks;
        const fieldId = `betrieb_${field}`;
        const isLocked = betriebLocks[lockKey];

        return (
            <div>
                <label className={LABEL_CLASS}>{label}</label>
                <input
                    type="text"
                    name={field}
                    autoComplete={isLocked ? 'off' : BETRIEB_AUTOCOMPLETE[field]}
                    value={betriebData[field]}
                    readOnly={isLocked}
                    onChange={(e) => !isLocked && updateBetriebField(field, e.target.value)}
                    className={getInputClass(isLocked ? READONLY_INPUT_CLASS : INPUT_CLASS, fieldId)}
                />
                {renderFieldError(fieldId)}
            </div>
        );
    };

    const renderSignatureTable = () => (
        <div className="av-table-wrap">
            <table>
                <thead>
                    <tr>
                        <th style={{ width: '10%' }}>Lfd. Nr.</th>
                        <th style={{ width: '42%' }}>Name des Mitarbeiters (Druckbuchstaben)</th>
                        <th style={{ width: '18%' }}>Datum</th>
                        <th style={{ width: '30%' }}>Unterschrift</th>
                    </tr>
                </thead>
                <tbody>
                    {Array.from({ length: SIGNATURE_ROW_COUNT }, (_, index) => (
                        <tr key={index} className="signature-row">
                            <td>{index + 1}</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );

    const renderContractDocument = () => (
        <div ref={printContainerRef} id="pepapers-mitfuehrpflicht-print" className="w-full h-auto overflow-visible">
            <style>{MF_CONTRACT_PDF_CSS}</style>
            <div className={`${A4_PREVIEW_PAGE_CLASS} min-h-[297mm]`}>
                <div className="pdf-letterhead text-center">
                    <h1>Sammelbestätigung Mitführpflicht &amp; Zeiterfassung</h1>
                    <h2>PreisExpert · PEPapers · § 2a SchwarzArbG / MiLoG</h2>
                </div>

                <div className="av-meta-grid">
                    <div className="av-meta-col">
                        <p className="av-meta-label">Betrieb / Arbeitgeber</p>
                        <p>
                            <strong>{betriebData.firmenname || '____________'}</strong>
                            {betriebData.strasse ? (
                                <>
                                    <br />
                                    {betriebData.strasse}
                                </>
                            ) : null}
                            {betriebData.plz || betriebData.ort ? (
                                <>
                                    <br />
                                    {[betriebData.plz, betriebData.ort].filter(Boolean).join(' ')}
                                </>
                            ) : null}
                        </p>
                    </div>
                    <div className="av-meta-col">
                        <p className="av-meta-label">Dokument</p>
                        <p>
                            <strong>Sammelbestätigung</strong>
                            <br />
                            § 2a SchwarzArbG / MiLoG
                            <span className="av-meta-date">Datum: {formatTodayGerman()}</span>
                        </p>
                    </div>
                </div>

                <div className="av-doc-section">
                    <h3>1. Gesetzliche Grundlage</h3>
                    <p className={DOC_P_CLASS}>
                        Gemäß § 2a Abs. 1 Schwarzarbeitsbekämpfungsgesetz (SchwarzArbG) sind Beschäftigte im
                        Friseurhandwerk verpflichtet, bei Ausübung ihrer Tätigkeit ein gültiges Ausweisdokument
                        mitzuführen. Als Ausweisdokumente gelten insbesondere Personalausweis, Reisepass sowie anerkannte
                        Pass- oder Ausweisersatzdokumente.
                    </p>
                </div>

                <div className="av-doc-section">
                    <h3>2. Hinweis des Arbeitgebers</h3>
                    <p className={DOC_P_CLASS}>
                        Der Arbeitgeber weist alle Mitarbeitenden ausdrücklich darauf hin, dass das mitzuführende
                        Ausweisdokument während der Arbeitszeit im Original mitzuführen ist. Die Vorlage auf Anforderung
                        durch den Arbeitgeber oder berechtigte Kontrollbehörden ist verpflichtend.
                    </p>
                </div>

                <div className="av-doc-section">
                    <h3>3. Arbeitszeiten – Erfassung und Korrektur</h3>
                    <p className={DOC_P_CLASS}>
                        Entsprechend den Vorgaben des Mindestlohngesetzes (MiLoG) ist der Arbeitgeber verpflichtet, die
                        Arbeitszeit der Beschäftigten elektronisch und revisionssicher aufzuzeichnen. Erfasst werden
                        Beginn, Ende und Dauer der täglichen Arbeitszeit. Mitarbeitende sind verpflichtet, ihre
                        Arbeitszeiten korrekt zu erfassen und erforderliche Korrekturen unverzüglich mitzuteilen bzw. zu
                        veranlassen.
                    </p>
                </div>

                <div className="av-doc-section">
                    <h3>4. Bestätigung der Mitarbeitenden</h3>
                    <p className={DOC_P_CLASS}>
                        Die unterzeichnenden Mitarbeitenden bestätigen hiermit, über die gesetzliche Mitführpflicht des
                        Ausweisdokuments nach § 2a SchwarzArbG belehrt worden zu sein. Sie erkennen die Verpflichtung zur
                        aktiven Mitwirkung bei der elektronischen, revisionssicheren Arbeitszeiterfassung an und
                        verpflichten sich, erforderliche Korrekturen ihrer Arbeitszeiten unverzüglich zu melden bzw. zu
                        veranlassen.
                    </p>
                </div>

                <div className="av-doc-section">
                    <h3>5. Unterschriftenliste</h3>
                    <p className={DOC_P_CLASS}>
                        Bitte Name in Druckbuchstaben eintragen, Datum setzen und unterschreiben.
                    </p>
                    {renderSignatureTable()}
                </div>
            </div>
        </div>
    );

    if (!isOpen) return null;

    const modalWidthClass = currentStep === 2 ? 'max-w-4xl' : 'max-w-lg';

    return createPortal(
        <>
            <div
                className="fixed inset-0 bg-stone-900/70 dark:bg-black/90 z-[100000] backdrop-blur-md print:hidden"
                onClick={handleClose}
                aria-hidden="true"
            />
            <div className="fixed inset-x-0 top-[8.5rem] md:top-36 bottom-0 z-[100001] flex items-start justify-center overflow-hidden p-4 pb-8 font-sans print:inset-0 print:top-0 print:overflow-visible print:p-0">
                <div
                    className={`bg-pe-card dark:bg-[#111] rounded-2xl shadow-[0_0_40px_rgba(230,194,153,0.1)] border border-[#E6C299]/30 w-full ${modalWidthClass} max-h-[calc(100vh-9.5rem)] md:max-h-[calc(100vh-10rem)] flex min-h-0 flex-col justify-between overflow-hidden relative transition-all duration-200 my-2 print:shadow-none print:border-0 print:max-w-none print:max-h-none print:rounded-none print:my-0 print:bg-white`}
                    onClick={(e) => e.stopPropagation()}
                >
                    <button
                        type="button"
                        onClick={handleClose}
                        className="absolute top-4 right-4 text-pe-muted dark:text-slate-400 hover:text-pe-text dark:hover:text-white bg-pe-elevated dark:bg-[#1a1a1a] hover:bg-pe-hover dark:hover:bg-[#222] rounded-lg p-2 transition-colors border border-pe-border-strong dark:border-[#333] z-[60] print:hidden"
                        aria-label="Schließen"
                    >
                        <X className="w-4 h-4" />
                    </button>

                    <div className="bg-pe-elevated dark:bg-[#111622] z-50 shrink-0 print:hidden border-b border-pe-border dark:border-[#222]">
                        <div className="px-6 pt-10 pb-4">
                            <h3 className="text-lg font-bold text-pe-accent-text dark:text-[#E6C299] text-center uppercase tracking-widest pr-8 leading-snug">
                                Sammelbestätigung: Mitführpflicht &amp; Zeiterfassung
                            </h3>
                            <p className="text-center text-xs text-pe-muted dark:text-slate-400 uppercase tracking-widest mt-2">
                                Schritt {currentStep} von 2: {STEP_LABELS[currentStep]}
                            </p>
                        </div>
                    </div>

                    <div className="flex-1 min-h-0 overflow-y-auto px-6 py-5 custom-scrollbar print:p-0 print:overflow-visible">
                        {currentStep === 1 && (
                            <div className="space-y-4">
                                <p className="text-[10px] font-bold uppercase tracking-widest text-pe-accent-text dark:text-[#E6C299]/80 mb-3 border-b border-pe-border dark:border-[#222] pb-2">
                                    Betriebsdaten
                                </p>
                                <p className="text-xs text-stone-500 dark:text-slate-500 leading-relaxed mb-4">
                                    Die Betriebsdaten werden aus Ihrem Profil übernommen. Fehlende Angaben können Sie
                                    hier ergänzen.
                                </p>
                                <div className="space-y-4">
                                    {renderBetriebField('firmenname', 'Firma / Salonname')}
                                    {renderBetriebField('strasse', 'Straße & Hausnummer')}
                                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                                        {renderBetriebField('plz', 'PLZ')}
                                        <div className="sm:col-span-2">{renderBetriebField('ort', 'Ort')}</div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {currentStep === 2 && (
                            <div className="w-full min-h-0 pr-2 mb-6">{renderContractDocument()}</div>
                        )}
                    </div>

                    {currentStep === 2 && (
                        <PePapersDisclaimerGate
                            accepted={disclaimerAccepted}
                            onAcceptedChange={setDisclaimerAccepted}
                        />
                    )}

                    {currentStep === 2 && (
                        <div className="px-6 pt-3 print:hidden">
                            <PePapersStorageHint
                                hint={PE_PAPERS_STORAGE_HINTS['mitfuehrpflicht-zeiterfassung']}
                                variant="modal"
                            />
                        </div>
                    )}

                    <div className="px-6 py-4 border-t border-pe-border dark:border-[#222] shrink-0 print:hidden">
                        <div className="flex flex-wrap gap-3">
                            {currentStep > 1 && (
                                <button
                                    type="button"
                                    onClick={handleZurueck}
                                    className="flex-1 min-w-[120px] px-4 py-3 font-bold rounded-xl text-xs uppercase tracking-widest border bg-transparent hover:bg-pe-hover dark:hover:bg-[#222] border-pe-border-strong dark:border-[#444] text-pe-muted dark:text-gray-300 transition-colors"
                                >
                                    Zurück
                                </button>
                            )}

                            {currentStep === 1 ? (
                                <>
                                    <button
                                        type="button"
                                        onClick={() => void handleArchive(true)}
                                        disabled={isSaving}
                                        className="flex-1 min-w-[120px] px-4 py-3 font-bold rounded-xl text-xs uppercase tracking-widest border bg-transparent hover:bg-pe-hover dark:hover:bg-[#222] border-pe-border-strong dark:border-[#444] text-pe-muted dark:text-gray-300 transition-colors disabled:opacity-50"
                                    >
                                        {isSaving && archiveFeedback !== 'draft' ? 'Speichert...' : 'Später fortsetzen'}
                                    </button>
                                    <button
                                        type="button"
                                        onClick={handleWeiter}
                                        className="flex-1 min-w-[120px] px-4 py-3 font-bold rounded-xl text-xs uppercase tracking-widest bg-[#E6C299] hover:bg-[#d9b183] dark:hover:bg-white text-black transition-colors"
                                    >
                                        Dokument erstellen
                                    </button>
                                </>
                            ) : (
                                <>
                                    <button
                                        type="button"
                                        onClick={() => void handleArchive(true)}
                                        disabled={isSaving}
                                        className="flex-1 min-w-[140px] px-4 py-3 font-bold rounded-xl text-xs uppercase tracking-widest border bg-transparent hover:bg-pe-hover dark:hover:bg-[#222] border-pe-border-strong dark:border-[#444] text-pe-muted dark:text-gray-300 transition-colors disabled:opacity-50"
                                    >
                                        {archiveFeedback === 'draft' ? 'Gespeichert! ✓' : 'Später fortsetzen'}
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => void handleArchive(false)}
                                        disabled={isActionLocked || isSaving}
                                        className={getActionButtonClass(
                                            'flex-1 min-w-[140px] px-4 py-3 font-bold rounded-xl text-xs uppercase tracking-widest border bg-pe-card dark:bg-[#15171e] hover:bg-pe-hover dark:hover:bg-[#1a1d24] border-[#E6C299]/40 text-pe-accent-text dark:text-[#E6C299] transition-colors'
                                        )}
                                    >
                                        {isSaving && archiveFeedback !== 'draft'
                                            ? 'Speichert...'
                                            : archiveFeedback === 'success'
                                              ? 'Gespeichert! ✓'
                                              : 'Im Archiv speichern'}
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => void handleDownloadPdf()}
                                        disabled={isActionLocked || isPdfDownloading}
                                        className={getActionButtonClass(
                                            'flex-1 min-w-[140px] px-4 py-3 font-bold rounded-xl text-xs uppercase tracking-widest bg-gradient-to-b from-[#E6C299] to-[#b48a56] hover:from-[#f0d3b3] hover:to-[#cfa674] text-black transition-colors'
                                        )}
                                    >
                                        {isPdfDownloading ? 'PDF wird erstellt...' : 'Als PDF herunterladen'}
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => void handlePrintIsolated()}
                                        disabled={isActionLocked || isPdfDownloading}
                                        className={getActionButtonClass(
                                            'flex-1 min-w-[140px] px-4 py-3 font-bold rounded-xl text-xs uppercase tracking-widest border bg-transparent hover:bg-pe-hover dark:hover:bg-[#222] border-[#E6C299]/40 text-pe-accent-text dark:text-[#E6C299] transition-colors'
                                        )}
                                    >
                                        Ausdrucken
                                    </button>
                                </>
                            )}
                        </div>
                        {currentStep === 2 && archiveFeedback === 'error' && (
                            <p className="text-[10px] text-red-400 mt-2 text-center">
                                Archivierung fehlgeschlagen. Bitte erneut versuchen.
                            </p>
                        )}
                    </div>
                </div>
            </div>
        </>,
        document.body
    );
};

export default MitfuehrpflichtModal;
